import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  LocalStorageService, SessionStorageService
} from 'ngx-webstorage';
import {
  HttpInterceptor, HttpRequest, HttpHandler, HttpEvent
} from '@angular/common/http';
import AppConfigService from 'app/core/app-config.service';

@Injectable()
export default class AuthInterceptor implements HttpInterceptor {
  constructor(private localStorage: LocalStorageService, private sessionStorage: SessionStorageService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    request = request.clone({
      setHeaders: {
        'Ocp-Apim-Subscription-Key': AppConfigService.envConfig.ocpApimSubscriptionKeyValue
      }
    });
    if (!request || !request.url || (request.url.startsWith('http') && !(AppConfigService.envConfig.fssServicesBaseUrl && request.url.startsWith(AppConfigService.envConfig.fssServicesBaseUrl)))) {
      return next.handle(request);
    }

    const token = this.localStorage.retrieve('authenticationToken') || this.sessionStorage.retrieve('authenticationToken');
    if (token) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        },
        headers: request.headers.set('Cache-Control', 'no-cache').set('Pragma', 'no-cache')
      });
    }
    return next.handle(request);
  }
}
